import * as React from 'react'
import { styled } from '../../../common/ui'
import { theme } from '../theme'

export class Checkbox extends React.Component<
  {
    label: string
    value: string
    checked?: boolean
    onChange?: (value: boolean) => void
    onBlur?: () => void
  },
  {}
> {
  render() {
    const { onChange, onBlur, checked, value, label } = this.props
    return (
      <Styled onClick={() => onChange && onChange(!checked)}>
        <input
          type="checkbox"
          checked={this.props.checked}
          value={value}
          onChange={e => {
            onBlur && onBlur()
            onChange && onChange(!checked)
          }}
          onBlur={e => {
            onBlur && onBlur()
          }}
        />
        <label>{label}</label>
      </Styled>
    )
  }
}

const Styled = styled.div`
  display: block;
  > input {
    opacity: 0;
    margin: 0;
    position: absolute;
  }
  > input + label {
    position: relative;

    padding-left: 35px;
    padding-right: 35px;
    padding-top: 5px;
    min-height: 27px;
    display: inline-block;
    cursor: pointer;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 1px;
      width: 22px;
      height: 22px;
      border: 3px solid black;
      background: #f8f8f8;
    }
    &:after {
      content: '✔';
      position: absolute;
      top: 3px;
      left: 4px;
      font-size: 20px;
      color: black;
      transition: all 0.2s;
    }
    &:hover {
      &:before {
        border: 3px solid ${theme.colors.blue};
      }
    }
  }
  > input:not(:checked) + label {
    &:after {
      opacity: 0; /* coche invisible */
      transform: scale(0); /* mise à l'échelle à 0 */
    }
  }
  > input:disabled:not(:checked) + label {
    &:before {
      box-shadow: none;
      border-color: #bbb;
      background-color: #ddd;
    }
  }
  > input:checked + label {
    &:after {
      opacity: 1; /* coche opaque */
      transform: scale(1); /* mise à l'échelle 1:1 */
    }
  }
  > input:disabled:checked + label {
    &:after {
      color: #999;
    }
  }
  > input:disabled + label {
    color: #aaa;
  }
  > input:checked:focus + label,
  input:not(:checked):focus + label {
    &:before {
      border: 3px solid ${theme.colors.blue};
    }
  }
`
